import { faSquarePollVertical } from '@fortawesome/pro-regular-svg-icons';
import { faSquareCaretRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';

import { publicEnv } from '@/lib/env';
import { BracketNetworkIcon } from '@/modules/rankings/ppr/ranking-history/icons/BracketNetworkIcon';
import { TournamentEventMatch } from '@/modules/rankings/ppr/types';

interface PWRResultsContainerProps {
  match: TournamentEventMatch;
  tournamentUuid: string;
}

export const PWRResultsContainer = ({ match, tournamentUuid }: PWRResultsContainerProps) => {
  const videoUrl = match.videoSources?.[0]?.liveUrl || match.videoSources?.[0]?.archivedUrl;
  return (
    <div className='flex w-full flex-col gap-1 px-3 py-2 sm:w-[180px] sm:border-l sm:justify-center border-gray-200 text-[#5925DC]'>
      {match.matchUuid ? (
        <CustomLink
          href={`https://${publicEnv.NEXT_PUBLIC_HOME_ROOT_URL}/results/match/${match.matchUuid.toLowerCase()}`}
          className='flex items-center'
        >
          <FontAwesomeIcon icon={faSquarePollVertical} className='mr-2 h-4 w-4' />
          <p className='text-sm'>Results</p>
        </CustomLink>
      ) : null}
      {tournamentUuid && match.eventUuid ? (
        <a
          href={`${publicEnv.NEXT_PUBLIC_BRACKETS_URL}/tournaments/${tournamentUuid}/events/${match.eventUuid}/standings`}
          className='flex items-center'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Link to view bracket (opens in a new tab)'
        >
          <BracketNetworkIcon className='mr-2 h-4 w-4' />
          <p className='text-sm'>View Bracket</p>
        </a>
      ) : null}
      {videoUrl ? (
        <a
          href={videoUrl}
          className='flex items-center'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Link to match video (opens in a new tab)'
        >
          <FontAwesomeIcon icon={faSquareCaretRight} className='mr-2 h-4 w-4' />
          <p className='text-sm'>Match Video</p>
        </a>
      ) : null}
    </div>
  );
};
